/* global SideDrawer */

class CartDrawer extends SideDrawer {
  connectedCallback() {
    this.bindEvents();
    this.setupReopenAfterRefresh();
  }

  bindEvents() {
    this.openDrawerViaEventHandler = this.handleDrawerOpenViaEvent.bind(this);
    this.closeDrawerViaEventHandler = this.close.bind(this, null);
    this.cartRefreshHandler = this.cartRefreshHandler.bind(this);

    document.addEventListener('dispatch:cart-drawer:open', this.openDrawerViaEventHandler);
    document.addEventListener('dispatch:cart-drawer:close', this.closeDrawerViaEventHandler);
    document.addEventListener('dispatch:cart-drawer:refresh', this.cartRefreshHandler);

    this.addEventListener('on:cart-drawer:before-open', () => {
      theme.manuallyLoadImages(this);
      this.querySelectorAll('cc-cart-cross-sell').forEach((el) => el.init());
    });

    this.addEventListener('on:cart:after-merge', () => {
      theme.manuallyLoadImages(this);
      this.querySelectorAll('cc-cart-cross-sell').forEach((el) => el.init());
    });
  }

  disconnectedCallback() {
    document.removeEventListener('dispatch:cart-drawer:refresh', this.cartRefreshHandler);
    document.removeEventListener('dispatch:cart-drawer:open', this.openDrawerViaEventHandler);
    document.removeEventListener('dispatch:cart-drawer:close', this.closeDrawerViaEventHandler);

    window.removeEventListener('beforeunload', this.saveDrawerStateBeforeUnload);
  }

  /**
   * Salva o estado do drawer antes de atualizar a página
   * e reabre no próximo carregamento, se ainda estiver na mesma URL.
   */
  setupReopenAfterRefresh() {
    this.saveDrawerStateBeforeUnload = () => {
      try {
        const drawerIsOpen =
          this.hasAttribute('open') ||
          this.getAttribute('aria-hidden') === 'false';

        if (drawerIsOpen) {
          sessionStorage.setItem('cartDrawerReopen', 'true');
          sessionStorage.setItem('cartDrawerReopenUrl', window.location.href);
          sessionStorage.setItem('cartDrawerReopenUntil', String(Date.now() + 10000));
        } else {
          sessionStorage.removeItem('cartDrawerReopen');
          sessionStorage.removeItem('cartDrawerReopenUrl');
          sessionStorage.removeItem('cartDrawerReopenUntil');
        }
      } catch (error) {
        // Ignora erro de sessionStorage.
      }
    };

    window.addEventListener('beforeunload', this.saveDrawerStateBeforeUnload);

    let shouldReopen = false;

    try {
      const wasOpen = sessionStorage.getItem('cartDrawerReopen') === 'true';
      const savedUrl = sessionStorage.getItem('cartDrawerReopenUrl');
      const reopenUntil = Number(sessionStorage.getItem('cartDrawerReopenUntil') || 0);

      shouldReopen =
        wasOpen &&
        savedUrl === window.location.href &&
        Date.now() <= reopenUntil;
    } catch (error) {
      shouldReopen = false;
    }

    if (!shouldReopen) return;

    try {
      sessionStorage.removeItem('cartDrawerReopen');
      sessionStorage.removeItem('cartDrawerReopenUrl');
      sessionStorage.removeItem('cartDrawerReopenUntil');
    } catch (error) {
      // Ignora erro de sessionStorage.
    }

    window.requestAnimationFrame(() => {
      this.open(null);
    });
  }

  /**
   * Handle when the drawer is opened via an event
   * @param {object} evt - Event object.
   */
  handleDrawerOpenViaEvent(evt) {
    this.open(evt.detail ? evt.detail.opener : null);
  }

  /**
   * Trigger refresh of contents
   */
  cartRefreshHandler() {
    this.querySelector('cart-form').refresh();
  }

  /**
   * Update section's cart-form element with new contents
   * @param {string} html - Whole-section HTML.
   */
  updateFromCartChange(html) {
    this.querySelector('cart-form').refreshFromHtml(html);
  }
}

window.customElements.define('cart-drawer', CartDrawer);